import axios from 'axios'
import * as utils from './api-utils'

export default {
  send(data) {
    return axios.post(utils.getApiUrl('/contacts'), data)
  },
}
